
import axios from "@/axios.js"

export default {
  fetchItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/clients")
        .then((response) => {
          commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsFullName({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/fullNameClients")
        .then((response) => {
          commit('SET_ITEMS_FULL_NAME', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/client", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(response.data.client, {id: response.data.client.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM', response.data.client)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/client/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchCountItemsHaveInvoice({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/clientsHaveInvoice")
        .then((response) => {
          commit('SET_CLIENTS_HAVE_INVOICE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },




}
